import { render, staticRenderFns } from "./templateName.vue?vue&type=template&id=f4a4af3a&scoped=true"
import script from "./templateName.vue?vue&type=script&lang=js"
export * from "./templateName.vue?vue&type=script&lang=js"
import style0 from "./templateName.vue?vue&type=style&index=0&id=f4a4af3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a4af3a",
  null
  
)

export default component.exports